import { OptionGroup } from '@models/item';
import { isEqual, differenceBy } from 'lodash';

const temperatureOptions = ['HOT', 'ICE'];
const cupOptions = ['머그컵', '일회용컵', '텀블러'];
const onlyIceOptions = ['Only ICE'];
const onlyHotOptions = ['Only HOT'];

function useIconOptionGroups(optionGroups: OptionGroup[]) {
    const iconOptionGroups = optionGroups
        .filter((optionGroup) => {
            const optionNames = optionGroup.options
                .map((option) => option.name)
                .sort();
            return isEqual(optionNames, temperatureOptions)
                || isEqual(optionNames, cupOptions)
                || isEqual(optionNames, onlyIceOptions)
                || isEqual(optionNames, onlyHotOptions);
        });

    const textOptionGroups = differenceBy(
        optionGroups,
        iconOptionGroups,
        'optionGroupId',
    );
    return {
        iconOptionGroups,
        textOptionGroups,
    };
}

export default useIconOptionGroups;
